import { flattenEmails } from '../../../../../Features/letterBox/api/emailTree';
import React, { useState } from 'react'
import { FormGroup, Input, Label, Nav, NavItem, NavLink } from 'reactstrap';
import { Href } from '../../../../../Utils/Constants';
import MailBody from './MailBody';
import { emailNavTab } from '../../../../../Data/Applications/LetterBox';
import DashboardSvgIcon from '../../../../../Utils/CommonComponents/DashboardSvgIcon';
import { fieldEmail } from '../../../../../Features/letterBox/api/types';

type MailHeaderProps = {
  listEmail: fieldEmail[] | [];
  selectedIds: number[];
  setSelectedIds: React.Dispatch<React.SetStateAction<number[]>>;
  onDeleteIds: (ids: number[]) => void;
  isDeleting: boolean;
};

export default function MailHeader({ listEmail, selectedIds, setSelectedIds, onDeleteIds, isDeleting }: MailHeaderProps) {
    const [navId, setNavId] = useState("pills-important-tab")
    const allEmails = flattenEmails(listEmail);
    const allSelected = allEmails.length > 0 && allEmails.every(email => selectedIds.includes(email.id));
    const toggleAll = () => {
        if (allSelected) {
            setSelectedIds([]);
            return;
        }
        setSelectedIds(allEmails.map((email) => email.id));
    };

    return (
        <div className="mail-header-wrapper">
            <div className="mail-header">
                <FormGroup check inline>
                    <Input
                      className="checkbox-primary"
                      id="emailCheckboxA"
                      type="checkbox"
                      value="option1"
                      onChange={toggleAll}
                      checked={allSelected}
                    />
                    <Label htmlFor="emailCheckboxA" check></Label>
                    <Nav className="email-tabs">
                        {emailNavTab.map((data) => (
                            <NavItem key={data.id}>
                                <NavLink href={Href} className={navId === data.id ? 'active' : ''} onClick={() => setNavId(data.id)}>
                                    <DashboardSvgIcon className='stroke-icon' iconId={data.icon} />
                                    <span>{data.title}</span>
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </FormGroup>
            </div>
            <MailBody
              unreadCount={allEmails.filter(email => email.is_read === 0 && email.is_deleted === 0 && email.typeID !== 2).length}
              selectedIds={selectedIds}
              onDeleteIds={onDeleteIds}
              isDeleting={isDeleting}
            />
        </div>
    )
}
